exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".positional-preview {\n  border: 1px solid #ffe1bf;\n  height: 200px;\n  position: relative;\n  width: 100%; }\n  .positional-preview__sample {\n    border: 2px solid #9c312a;\n    background-color: rgba(30, 30, 30, 0.5);\n    position: absolute; }\n\n.positional-inputs {\n  display: none; }\n\n.positional-alignment > span {\n  vertical-align: 5px; }\n\n.inner-content-align {\n  margin-left: 10px;\n  padding-top: 5px;\n  text-align: center;\n  width: 80px; }\n  .inner-content-align span {\n    display: inline-block; }\n\n.resizer {\n  background-color: #9c312a;\n  height: 10px;\n  width: 10px;\n  position: absolute; }\n  .resizer--top-left {\n    top: -2px;\n    left: -2px; }\n  .resizer--top-right {\n    top: -2px;\n    right: -2px; }\n  .resizer--bottom-right {\n    bottom: -2px;\n    right: -2px; }\n  .resizer--bottom-left {\n    bottom: -2px;\n    left: -2px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/FormPosition/styles.scss
// module id = 943
// module chunks = 0